<template>
    <div>
        <!-- <AIDataPattern v-if="pageType === 'dataMode'" /> -->
        <AIControl v-if="pageType === 'boardMode'" />
        <AIEyes v-if="pageType === 'aiEyes'" />
    </div>
</template>

<script>
import AIControl from "./ctrIndex.vue";
// import AIDataPattern from "@/views/DataPattern/ziguang/index.vue";
import AIEyes from "./AIEyes/index.vue";

export default {
    components: {
        AIControl,
        // AIDataPattern,
        AIEyes,
    },
    data() {
        return {
            urlConfig: {},
            pageType: 'aiEyes',
        };
    },
    watch: {
        // "$store.state.urlConfig": {
        //     handler(newValue) {
        //         this.urlConfig = newValue;
        //     },
        //     immediate: true,
        // },
        // "$store.state.displayMode": {
        //     handler(newValue) {
        //         this.pageType = newValue;
        //     },
        //     immediate: true,
        // },
    },
};
</script>
